import Decimal from "decimal.js";

export class DecimalAssertionError extends Error {}

export function assertIsDecimalFinite(value: Decimal, contextName: string) {
  if (!value.isFinite()) {
    throw new DecimalAssertionError(`Assertion error: ${contextName} is not Finite number`);
  }
}

export function createFiniteDecimalFromAnyString(input: string, fieldName: string): Decimal {
  const value = new Decimal(input.trim());
  assertIsDecimalFinite(value, fieldName);
  return value;
}

export function createFiniteDecimalFromAnyStringNonStrict(input: string): Decimal | null {
  try {
    const value = new Decimal(input.trim());
    return value.isFinite() ? value : null;
  } catch {
    return null;
  }
}
